import React from 'react';
import { Text, View } from 'react-native';
import {styles} from "./HexagonViewStyle";

interface HexagonViewProps {
    title: string;
}

export const HexagonView = ({title}: HexagonViewProps) =>{

    return (
      <View style={styles.hexagon}>
        <View style={styles.hexagonInner}>
          <Text style={styles.title}>{title}</Text>
        </View>
        <View style={styles.hexagonBefore} />
        <View style={styles.hexagonAfter} />
      </View>
    );
}

export default HexagonView;